import { getPositions } from '../../utils/getPositionsUtils';
import { ConfigRulesProps } from './config.types';

export const germanConfig = [
  'E', 'S', 'K', 'I', 'S', 'T', 'A', 'F', 'Ü', 'N', 'F',
  'Z', 'E', 'H', 'N', 'Z', 'W', 'A', 'N', 'Z', 'I', 'G',
  'D', 'R', 'E', 'I', 'V' , 'I', 'E', 'R', 'T', 'E', 'L',
  'V', 'O', 'R', 'F', 'U', 'N', 'K', 'N', 'A', 'C', 'H',
  'H', 'A', 'L', 'B', 'A', 'E', 'L', 'F', 'Ü', 'N', 'F',
  'E', 'I', 'N', 'S', 'X', 'A', 'M', 'Z', 'W', 'E', 'I',
  'D', 'R', 'E', 'I', 'P', 'M', 'J', 'V', 'I', 'E', 'R',
  'S', 'E', 'C', 'H', 'S', 'N', 'L', 'A', 'C', 'H', 'T',
  'S', 'I', 'E', 'B', 'E', 'N', 'Z', 'W', 'Ö', 'L', 'F',
  'Z', 'E', 'H', 'N', 'E', 'U', 'N', 'K', 'U', 'H', 'R'
];

export const germanConfigRules: ConfigRulesProps = {
  start: [...getPositions(['es', 'ist'], germanConfig)],
  end: getPositions(['uhr'], germanConfig),
  one: getPositions(['ein'], germanConfig),
  oneExt: getPositions(['eins'], germanConfig),
  two: getPositions(['zwei'], germanConfig),
  three: getPositions(['drei'], germanConfig),
  four: getPositions(['vier'], germanConfig),
  five: getPositions(['fünf'], germanConfig),
  six: getPositions(['sechs'], germanConfig),
  seven: getPositions(['sieben'], germanConfig),
  eight: getPositions(['acht'], germanConfig),
  nine: getPositions(['neun'], germanConfig),
  ten: getPositions(['zehn'], germanConfig),
  eleven: getPositions(['elf'], germanConfig),
  twelve: getPositions(['zwölf'], germanConfig),
  fiveAfter: getPositions(['fünf', 'nach'], germanConfig, { preferFirst: true }),
  tenAfter: getPositions(['zehn', 'nach'], germanConfig, { preferFirst: true }),
  quarterAfter: getPositions(['viertel', 'nach'], germanConfig),
  twentyAfter: getPositions(['zwanzig', 'nach'], germanConfig),
  fiveBeforeHalf: getPositions(['fünf', 'vor', 'halb'], germanConfig, { preferFirst: true }),
  half: getPositions(['halb'], germanConfig),
  fiveAfterHalf: getPositions(['fünf', 'nach', 'halb'], germanConfig, { preferFirst: true }),
  fiveBefore: getPositions(['fünf', 'vor'], germanConfig, { preferFirst: true }),
  tenBefore: getPositions(['zehn', 'vor'], germanConfig, { preferFirst: true }),
  quarterBefore: getPositions(['viertel', 'vor'], germanConfig),
  twentyBefore: getPositions(['zwanzig', 'vor'], germanConfig),
};
